import React, { useState } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { apiFetch, formatPlural } from 'functions';

// BOOTSTRAP COMPONENTS
import { Badge } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import VehicleManagementItemStatus from './VehicleManagementItemStatus';

// STYLE
import styles from './vehicleManagement.module.scss';
import { useRecordContext } from 'helpers/getRecordData';

// MAIN COMPONENT
const VehicleManagementItem = props => {
  const { typeInfo, status = [], history = [], inventoryId, refetchRecord, downloadFile } = props;

  const { record: { age_of_vehicle } = {} } = useRecordContext();

  const { key, label, options = [] } = typeInfo;

  const [task, setTask] = useState('');

  const addTask = () => {
    apiFetch({
      method: 'POST',
      endpoint: ENDPOINTS.inventory.miscTask.addTask(inventoryId),
      params: {
        tracking_misc_task_name: task
      },
      onSuccess: () => {
        refetchRecord();
        setTask('');
      },
      loadingMessage: 'Saving task',
      successMessage: 'Task saved',
      errorMessage: 'Unable to save task.'
    });
  };

  const renderRightHeader = () =>
    key === 'misc' ? (
      <Form.Row>
        <Form.Control
          value={task}
          placeholder="Task Name"
          onChange={e => setTask(e.target.value)}
          size="sm"
          append={{ use: 'send', onClick: addTask }}
          required
          useFormik={false}
        />
      </Form.Row>
    ) : status.length ? (
      displayStatus()
    ) : (
      ''
    );

  const displayStatus = () => {
    const { tracking_code_color, tracking_code_name } = status[0];
    return (
      <>
        <Badge className={styles.badge} bg={tracking_code_color}>
          <span>{tracking_code_name}</span>
        </Badge>
        <Badge className={styles.badge} bg="secondary">
          <span>Age: {formatPlural(age_of_vehicle, 'day', false)}</span>
        </Badge> 
      </>
    );
  };

  // RENDER
  return (
    <Card
      className={styles.card}
      title={label}
      tools={renderRightHeader()}
      anchor={key}
      body={status.map(
        (
          {
            tracking_type_id,
            tracking_code_name,
            tracking_code_id,
            track_misc_id = null,
            tracking_misc_task_name = null
          },
          i
        ) => (
          <VehicleManagementItemStatus
            key={`${key}-${i}`}
            title={label}
            options={options}
            history={track_misc_id ? history?.filter(v => v.track_misc_id === track_misc_id) : history}
            inventoryId={inventoryId}
            trackingCodeId={tracking_code_id}
            trackingTypeId={tracking_type_id}
            trackingType={key}
            trackingCodeName={tracking_code_name}
            trackMiscTaskId={track_misc_id}
            trackMiscTaskName={tracking_misc_task_name}
            downloadFile={downloadFile}
          />
        )
      )}
    />
  );
};

// EXPORT
export default VehicleManagementItem;
